import { clearAuthPersistence } from '~/lib/authStorage';
export const useLogout = (destination = '/') => {
  const target = typeof destination === 'string' ? destination : '/';
  clearAuthPersistence();

  useTokens().$reset();
  useUser().$reset();
  useCosmo().$reset();
  useOwnerStore().reset();
  useParkerStore().reset();

  return navigateTo(target);
}
